export const FETCH_EMAILRULES_BEGIN="FETCH_EMAILRULES_BEGIN";
export const FETCH_EMAILRULES_SUCCESS="FETCH_EMAILRULES_SUCCESS";
export const FETCH_EMAILRULES_FAILURE = "FETCH_EMAILRULES_FAILURE";

export const FETCH_EMAILRULESATTACHEMENT_BEGIN = "FETCH_EMAILRULESATTACHEMENT_BEGIN";
export const FETCH_EMAILRULESATTACHEMENT_SUCCESS = "FETCH_EMAILRULESATTACHEMENT_SUCCESS";
export const FETCH_EMAILRULESATTACHEMENT_FAILURE = "FETCH_EMAILRULESATTACHEMENT_FAILURE";